import React from "react";
import {
  Container,
  Title,
  ChartContainer,
  LegendContainer,
  Legend,
  LegendLabel,
  LegendText,
  LegendValue,
  LegendMark,
  Value,
} from "./styled";

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { PieChart } from '@mui/x-charts/PieChart';

function formatNumber(num) {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace('.0', '') + 'M';
  }

  if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace('.0', '') + 'K';
  }

  return num?.toString();
}

export default function PieChartCard({ data }) {

  const valueFormatter = (value) => `${value.value}%`;

  const calculatePercentage = (value, total) => {
    if (total === 0) return 0;
    return ((value / total) * 100).toFixed(2);
  }

  const totalComments = data?.[0]?.sentiment_positive + data?.[0]?.sentiment_negative + data?.[0]?.sentiment_neutral;
  const sentimentPositive = calculatePercentage(data?.[0]?.sentiment_positive, totalComments);
  const sentimentNegative = calculatePercentage(data?.[0]?.sentiment_negative, totalComments);
  const sentimentNeutral = calculatePercentage(data?.[0]?.sentiment_neutral, totalComments);

  return (
    <Container>
      <Title>Sentimento dos comentários</Title>

      <ChartContainer>
        <PieChart
          sx={`.css-1mzvvpl-MuiPieArc-root {
              stroke: none !important;
          }`}
          height={197}
          series={[
            {
              data: [
                { value: sentimentPositive, color: "#AF00E3" },
                { value: sentimentNegative, color: "#2724D3" },
                { value: sentimentNeutral, color: "#DFDAFD" },
              ],
              innerRadius: 50,
              arcLabel: (params) => params.label ?? '',
              arcLabelMinAngle: 20,
              valueFormatter,
            }
          ]}
          legend={{
            hidden: true,
          }}
          skipAnimation={false}
        />

        <LegendChart data={data} />

      </ChartContainer>
    </Container>
  );
}

function LegendChart({ data }) {

  return (
    <LegendContainer>
      <Legend>
        <LegendLabel>
          <LegendText>
            Positivo
          </LegendText>
          <HelpOutlineIcon sx={{ fontSize: 14 }} />
        </LegendLabel>
        <LegendValue>
          <LegendMark />
          <Value>{formatNumber(data?.[0].sentiment_positive.toFixed(2)) || 0}%</Value>
        </LegendValue>
      </Legend>

      <Legend>
        <LegendLabel>
          <LegendText>
            Negativo
          </LegendText>
          <HelpOutlineIcon sx={{ fontSize: 14 }} />

        </LegendLabel>
        <LegendValue>
          <LegendMark customColor={"#2724D3"} />
          <Value>{formatNumber(data?.[0].sentiment_negative.toFixed(2)) || 0}%</Value>
        </LegendValue>
      </Legend>

      <Legend>
        <LegendLabel>
          <LegendText>
            Neutro
          </LegendText>
          <HelpOutlineIcon sx={{ fontSize: 14 }} />

        </LegendLabel>
        <LegendValue>
          <LegendMark customColor={"#DFDAFD"} />
          <Value>{formatNumber(data?.[0].sentiment_neutral.toFixed(2)) || 0}%</Value>
        </LegendValue>
      </Legend>
    </LegendContainer>
  );
}
